import { render, staticRenderFns } from "./Page3Chart1.vue?vue&type=template&id=0c84f09e&scoped=true&"
import script from "./Page3Chart1.vue?vue&type=script&lang=ts&"
export * from "./Page3Chart1.vue?vue&type=script&lang=ts&"
import style0 from "./Page3Chart1.vue?vue&type=style&index=0&id=0c84f09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84f09e",
  null
  
)

export default component.exports